<div class="center-canvas">
    <button mat-fab aria-label="Center Button" (click)="centerAction()" matTooltip="Center into Diagram" matTooltipPosition="above">
        <mat-icon>my_location</mat-icon>
    </button>
</div>